import React, { useState, useEffect, useCallback } from "react";
import { useFetchData } from "../../../../hooks/useFetchData";
import { topicManagement } from "../../../../utils/mainTabs/organize/topicManagement";
import {
  deleteTopicByIDActionHandler,
  getAllTopicsActionHandler,
  getTopicByIDActionHandler,
} from "../../../../store/actions/actionHandlers/organizeActionHandler";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import TopicShotClassPreviewData from "./TopicShotClassPreviewData/TopicShotClassPreviewData";

import { useDispatch } from "react-redux";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import { useNavigate, useOutletContext } from "react-router";
import Modal from "../../../../components/Common/Modal/Modal";
import classes from './TopicTable.module.scss'
import { FormattedMessage } from "react-intl";

const TopicTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pageSize = 8;
  const { tenantName } = useOutletContext();
  const [tableTopicColumns, setTableTopicColumns] = useState([]);
  const [previewSelectedDataModalOpen, setPreviewSelectedDataModalOpen] =
    useState(false);
  const [topicShotclassDataByID, setTopicShotclassDataByID] = useState([]);
  const [previewCreator, setPreviewCreator] = useState();
  const [loader, setLoader] = useState(false);
  const { columns, topicColumns, searchPlaceHolder, searchTopicPlaceHolder } =
    topicManagement;
  const [shotclassId, setShotclassId] = useState(0);
  const handleDelete = useCallback((shotclassId) => {
    setShotclassId(shotclassId);
  }, []);
  useEffect(() => {
    let newTopicColumns = topicColumns(
      handleDelete,
      handleEdit,
      handlePreview,
      navigate,
      tenantName
    );
    setTableTopicColumns(newTopicColumns);
  }, [columns, handleDelete]);

  const handleDeleteTopic = () => {
    dispatch(deleteTopicByIDActionHandler(shotclassId)).then((response) => {
      if (response) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            "Subtopic  has been deleted successfully"
          )
        );
        handleSearchQuery("");
      }
    });
    handleDelete(0);
  };
  const handleEdit = () => {};

  const handlePreview = (classID, firstName, lastName) => {
    setPreviewSelectedDataModalOpen(true);
    setPreviewCreator(firstName + " " + lastName);
    dispatch(getTopicByIDActionHandler(classID)).then((response) => {
      if (response?.status === 200 && response?.data) {
        setTopicShotclassDataByID(response?.data);
      }
    });
  };
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    searchQuery,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getAllTopicsActionHandler, pageSize);

  return (
    <>
      <DataTable
        columns={tableTopicColumns}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        loading={loading}
        uniqueFieldName={"TopicId"}
        fetchMoreData={handleCurrentPage}
        searchable
        searchQuery={searchQuery}
        setSearchQuery={handleSearchQuery}
        placeholder={searchTopicPlaceHolder}
      />
      {previewSelectedDataModalOpen && (
        <TopicShotClassPreviewData
          previewSelectedDataModalOpen={previewSelectedDataModalOpen}
          setPreviewSelectedDataModalOpen={setPreviewSelectedDataModalOpen}
          topicShotclassDataByID={topicShotclassDataByID}
          previewCreator={previewCreator}
          // previewCreatedOn={previewCreatedOn}
        />
      )}
      <Modal
        handleSubmit={handleDeleteTopic}
        isOpen={shotclassId}
        heading={"Shotclasses Message"}
        toggle={() => handleDelete(0)}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGROUP_CANCELBTN" />}
        width={"40.2"}
        height={"26.9"}
      >
        <div className={classes.modalBody}>
          <div className={classes.modalContent}>Are you sure you want to delete this Subtopic?</div>
        </div>
      </Modal>
    </>
  );
};

export default TopicTable;
